module.exports = __webpack_public_path__ + "img/KEY_LEARNING_LOGO.a9af3f2f.svg";